module.exports = __webpack_public_path__ + "static/img/IMG_20150307_154828.45cdce55.jpg";